import React from "react";
import {
  GalleryWrapper,
  GalleryContainer,
  GalleryHeader,
  GalleryDesc,
  GalleryButtons,
  GalleryButton,
  GalleryItems,
  GalleryItem,
} from "./style";
import { AppLayout } from "../../layout/Index";

const Gallery = () => {
  return (
    <AppLayout>
      <GalleryWrapper>
        <GalleryContainer>
          <GalleryHeader>Galleries</GalleryHeader>
          <GalleryDesc>Generated by the Stellar Art Community</GalleryDesc>
          <GalleryButtons>
            <GalleryButton className="activebtn">
              Community Generated
            </GalleryButton>
          </GalleryButtons>
        </GalleryContainer>

        <GalleryItems>
          <GalleryItem>
            <div>
              <img src="assets/gallery/a-1.png" alt="" />
              <img src="assets/gallery/a-3.png" alt="" />
              <img src="assets/gallery/a-2.png" alt="" />
              <img src="assets/gallery/a-4.png" alt="" />
              <img src="assets/gallery/a-5.png" alt="" />
              <img src="assets/gallery/a-1.png" alt="" />
              <img src="assets/gallery/a-3.png" alt="" />
              <img src="assets/gallery/a-2.png" alt="" />
              <img src="assets/gallery/a-4.png" alt="" />
              <img src="assets/gallery/a-5.png" alt="" />
            </div>
          </GalleryItem>
          <GalleryItem className="row-2">
            <div>
              <img src="assets/gallery/b-1.png" alt="" />
              <img src="assets/gallery/b-2.png" alt="" />
              <img src="assets/gallery/b-3.png" alt="" />
              <img src="assets/gallery/b-4.png" alt="" />
              <img src="assets/gallery/b-5.png" alt="" />
              <img src="assets/gallery/b-1.png" alt="" />
              <img src="assets/gallery/b-2.png" alt="" />
              <img src="assets/gallery/b-3.png" alt="" />
              <img src="assets/gallery/b-4.png" alt="" />
              <img src="assets/gallery/b-5.png" alt="" />
            </div>
          </GalleryItem>
          <GalleryItem className="">
            <div>
              <img src="assets/gallery/c-1.png" alt="" />
              <img src="assets/gallery/c-2.png" alt="" />
              <img src="assets/gallery/c-4.png" alt="" />
              <img src="assets/gallery/c-3.png" alt="" />
              <img src="assets/gallery/c-1.png" alt="" />
              <img src="assets/gallery/c-2.png" alt="" />
              <img src="assets/gallery/c-4.png" alt="" />
              <img src="assets/gallery/c-3.png" alt="" />
            </div>
          </GalleryItem>
        </GalleryItems>
      </GalleryWrapper>
    </AppLayout>
  );
};

export default Gallery;
